var _defs, _path, _path2, _polygon, _rect, _path3, _rect2, _rect3, _path4, _path5, _path6, _polygon2, _polygon3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHumanidad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f5333f;}.cls-2{fill:#011e41;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M365.17,88.68a186.27,186.27,0,0,0-230.13,0l-9.89-12.57a202.26,202.26,0,0,1,249.92,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M339,242.9a26.55,26.55,0,1,1,26.54-26.55A26.58,26.58,0,0,1,339,242.9Zm0-37.09a10.55,10.55,0,1,0,10.54,10.54A10.56,10.56,0,0,0,339,205.81Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "351.11 458.83 351.1 250.92 437.53 211.12 444.23 225.65 367.1 261.17 367.11 458.83 351.11 458.83"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 310.97,
    y: 250.69,
    width: 16,
    height: 208.42
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M161,242.9a26.55,26.55,0,1,1,26.55-26.55A26.58,26.58,0,0,1,161,242.9Zm0-37.09a10.55,10.55,0,1,0,10.55,10.54A10.55,10.55,0,0,0,161,205.81Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 92.01,
    y: 192.2,
    width: 16,
    height: 90.03,
    transform: "translate(-157.29 228.83) rotate(-65.27)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 173.03,
    y: 250.69,
    width: 16,
    height: 83.56
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.07,435.16l-16-.07L62.25,395a78.53,78.53,0,0,1,70.46-78l.17-55.79L55.77,225.65l6.7-14.53,86.44,39.81-.25,81.62h-8A62.51,62.51,0,0,0,78.25,395Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M145.15,460.12A56.8,56.8,0,1,1,202,403.33,56.85,56.85,0,0,1,145.15,460.12Zm0-97.59a40.8,40.8,0,1,0,40.8,40.8A40.84,40.84,0,0,0,145.15,362.53Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M250.11,164.64a32,32,0,1,1,32-32A32,32,0,0,1,250.11,164.64Zm0-48a16,16,0,1,0,16,16A16,16,0,0,0,250.11,116.64Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "268.08 458.11 268.08 179.38 377.93 116.34 385.89 130.22 284.08 188.64 284.08 458.11 268.08 458.11"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "232.14 458.11 216.14 458.11 216.14 188.65 114.07 130.22 122.02 116.33 232.14 179.37 232.14 458.11"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumanidad);
export default __webpack_public_path__ + "static/media/humanidad.b4b11d217d57ca0eeed7b7794f902cd5.svg";
export { ForwardRef as ReactComponent };